import { requester } from "@module/_core/infras/config/request/requester";
import {
    CheckInviterInfoDTO,
    CreateOrderDTO,
    CreateOrderResponse,
    CreatePaymentOrderDTO,
    CreatePaymentOrderResponse,
    GetCheckInviterInfoDTO,
    GetHistoryOrderDTO,
    GetOrderStatusDTO,
    GetSubscriptionEndDateDTO,
    HistoryOrderDTO
} from "../dto/order";
import { OrderEndpoint } from "@module/order/infras/config/endpointUrl";
import { appRequest } from "@module/_core/infras/config/request/axios";

export class OrderApi {
    static async getOrders() {
        return requester<HistoryOrderDTO[]>({
            requestFunc: () => appRequest.mapServer.get(OrderEndpoint.getOrders()),
            handleData: (data: GetHistoryOrderDTO) => data.data
        })();
    }

    static async checkInviterInformation(phoneNumber: string) {
        return requester<CheckInviterInfoDTO>({
            requestFunc: () => appRequest.mapServer.get(OrderEndpoint.checkInviterInformation(phoneNumber)),
            handleData: (data: GetCheckInviterInfoDTO) => data.data
        })();
    }

    static async checkInviterInformationByToken(token: string, inviterPhoneNumber: string) {
        return requester<CheckInviterInfoDTO>({
            requestFunc: () =>
                appRequest.mapServer.get(OrderEndpoint.checkInviterInformationByToken(token, inviterPhoneNumber)),
            handleData: (data: GetCheckInviterInfoDTO) => data.data
        })();
    }

    static async createOrder(createOrder: CreateOrderDTO) {
        return requester<string>({
            requestFunc: () => appRequest.mapServer.post(OrderEndpoint.createOrder(), createOrder),
            handleData: (data: CreateOrderResponse) => data.data.vnpPaymentUrl
        })();
    }

    static async getOrderStatus(orderId: string) {
        return requester({
            requestFunc: () => appRequest.mapServer.get(OrderEndpoint.getOrderStatus(orderId)),
            handleData: (data: GetOrderStatusDTO) => data.data
        })();
    }

    static async createOrderV2(createOrder: CreatePaymentOrderDTO) {
        return requester<string>({
            requestFunc: () => appRequest.mapServer.post(OrderEndpoint.createOrderV2(), createOrder),
            handleData: (data: CreatePaymentOrderResponse) => data.data.vnpPaymentUrl
        })();
    }

    static async getOrderStatusV2(orderId: string, token: string) {
        return requester({
            requestFunc: () => appRequest.mapServer.get(OrderEndpoint.getOrderStatusV2(orderId, token)),
            handleData: (data: GetOrderStatusDTO) => data.data
        })();
    }

    static async getSubscriptionEndDate(token: string) {
        return requester<string>({
            requestFunc: () => appRequest.mapServer.get(OrderEndpoint.getSubscriptionEndDate(token)),
            handleData: (data: GetSubscriptionEndDateDTO) => data.data.endDate
        })();
    }
}
